import * as React from 'react';
const TosseGrassaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m79.48 110.14-13.15 2.44M78.73 106.12l-8.13.02M80.22 114.15l-7.33 3.07M64.72 104.13c-1.42-.41-2.95-.5-4.5-.22-.92.17-1.79.47-2.59.87a9.86 9.86 0 0 0-5.31 10.65c.83 4.44 4.5 7.63 8.79 8.02.89.08 1.8.05 2.72-.12 1.55-.29 2.95-.93 4.12-1.82"
      className="prefix__cls-1"
    />
    <path
      d="M57.63 104.79c-.39-.8-.65-1.69-.72-2.67-.25-3.27 1.84-6.38 4.97-7.37a7.22 7.22 0 0 1 8.73 3.76M61.11 123.46c-.06.64-.03 1.3.09 1.96.73 3.91 4.49 6.5 8.4 5.77a7.215 7.215 0 0 0 5.87-6.54"
      className="prefix__cls-1"
    />
    <path
      d="M115.27 113.61c-3.71 2.73-7.69 4.93-12.07 6.21-3.06.89-6.91 1.78-9.85 0-1.28-.77-2.25-2.3-2.06-3.85.08-.68.36-1.31.44-1.98.08-.68-.08-1.19-.63-1.52-.49-.29-.95-.66-1.27-1.16s-.47-1.14-.3-1.71.73-1.01 1.29-.96c-.63-.1-1.24-.56-1.55-1.16s-.33-1.35-.07-1.97c.15-.36.38-.66.57-.99s.34-.72.28-1.11c-.05-.39-.27-.7-.64-.67-.66-.32-1.33-.64-1.9-1.12-2.1-1.76-1.9-3.72-.36-5.86 1.21-1.68 2.52-3.49 3.06-5.52.6-2.28.2-4.7.28-7.02.27-7.77 5.44-15.64 11.32-20.44 2.53-2.07 5.36-3.63 8.4-4.66 0 0 1.55-.73 5.7-1.31 10-1.39 20.4 1.52 25.66 10.58 3.25 5.34 4.71 11.75 4.19 17.99-.54 6.38-4.29 11.43-7.2 16.9-2.08 3.9-3.49 8.26-3.4 12.68M141.93 133.51c-2.55-3.76-4.65-8.32-5.87-12.83"
      className="prefix__cls-2"
    />
    <path
      d="M104.06 119.69c1.7 4.75 3.74 9.37 6.08 13.82M122.38 91.24c.69-1.49 1.74-2.87 3.18-3.54 1.45-.67 3.33-.47 4.37.78.77.92.97 2.21.99 3.42.06 3.03-.8 6.08-2.43 8.58-.73 1.12-1.64 2.16-2.78 2.81s-2.55.87-3.76.37"
      className="prefix__cls-2"
    />
    <path
      d="M125.59 94.92c-.3.8-.74 1.56-1.27 2.23-.02.03-.06.06-.09.04s.02-.08.03-.04"
      className="prefix__cls-2"
    />
    <path
      d="M120.83 120.73s4.07 3.33 4.07 7.66c0 2.25-1.82 4.07-4.07 4.07s-4.07-1.82-4.07-4.07c0-4.33 4.07-7.66 4.07-7.66"
      className="prefix__cls-1"
    />
  </svg>
);
export default TosseGrassaIcon;
